import { Injectable } from "@angular/core";
import { FormControlStatus, FormGroup } from "@angular/forms";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { EPreloginServiceCode, IResultNavigationDetails } from "@common/models";
import { ResultPageService, ResultService } from "@common/services";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subscription, timer } from "rxjs";
import { CommonService } from "src/app/common.service";
import { IPopupScreenData } from "src/app/common/models/popup-screen-data.model";
import { BaseFpxFormHelper, BaseFpxComponentState, BaseFpxChangeHandler } from "src/app/common/utils/base-fpx.form.component";
import { InfoPopupComponent } from "src/app/core/components/popup/info-popup/info-popup.component";
import { RetailStock } from "src/app/retail-common.service";
import { PreLoginService } from "../../pre-login.service";
import { OtpPageService } from "./otp-page.service";
import { CustomerService } from "src/app/services/customer.service";
import { NativeStorageService } from "src/app/services/mobile/native-storage.service";

export class OtpPageState extends BaseFpxComponentState {
  navNextUrl: any;
  navBackUrl: any;
  mobileNum: string;
  emailId: string;
  additionalDetails;
  expireSec: number = 300;
  countDown: Subscription;
  displayTimer: string;
  disableResend: boolean;
  otpError: string;
  isError: boolean = false;
  buttonEnable: boolean;
  submitclickCount: number = 3;
  activeSpan: string;
  activeSpanValue: string;
  otpVerify: boolean;
  registeredUser: string;
  isOtpChannel:boolean = true;
  otpChannelList = [{id:'1',text:"kBSJKBS"}]
  whatsapp: string;
}

@Injectable()
export class OtpPageHelper extends BaseFpxFormHelper<OtpPageState>{


  constructor(private otpPageService: OtpPageService, private _commonService: CommonService,
    public _preloginService: PreLoginService,
    protected translate: TranslateService,
    private _dialog: MatDialog,
    private _nativeStorage: NativeStorageService,
    private _router: Router,
    private _customerService: CustomerService,
    public _resultService: ResultService,
    private dialogRef: MatDialogRef<InfoPopupComponent>,
    private _retailStock: RetailStock
  ) {
    super(new OtpPageState());
  }

  timer(resetTime?) {
    if (resetTime) {
      this.state.expireSec = resetTime;
    }

    this.state.countDown = timer(0, 1000).subscribe((x) => {
      this.state.expireSec = this.state.expireSec - 1;
      var m: any = Math.floor(this.state.expireSec / 60);
      var s: any = this.state.expireSec % 60;
      m = m < 10 ? '0' + m : m;
      s = s < 10 ? '0' + s : s;
      this.state.displayTimer = m + ':' + s;
      if (this.state.expireSec === 0) {
        this.state.isError = true;
        this.state.buttonEnable = false;
        this.state.otpVerify = true;
        this.state.otpError = "OTP expired. Kindly click on the 'Resend code' to generate a new OTP.";
        this.state.countDown.unsubscribe();
      }
    });

  }

  startTimer() {
    this.state.countDown.unsubscribe();
    this.timer(this.state.expireSec)
  }

  setNxtAndBackNav() {
    this.state.mobileNum = this._preloginService.getUserTwoFactor()?.mobile;
    this.state.emailId = this._preloginService.getUserTwoFactor()?.email;
    this.state.whatsapp = this._preloginService.getUserTwoFactor()?.whatsapp;

    if (this._preloginService.getFlow() == 'login') {
      if (!this._commonService.isHybrid()) {
        this.state.navNextUrl = 'doWelcome';
      } else {
        this._nativeStorage.retriveData('registeredUser').then(
          (value) => {
            this.state.registeredUser = value;
            if (!value) {
              this.state.navNextUrl = ['login', 'setMPIN'];
            } else {
              this.state.navNextUrl = 'doWelcome';
            }
          }).catch((reson: any) => {
            this.state.navNextUrl = ['login', 'setMPIN'];
          });
      }
      this.state.navBackUrl = ['login'];
    }
    else if (this._preloginService.getFlow() == 'trouble-login') {
      this.state.navBackUrl = ['login', 'trouble-login'];
      this.state.navNextUrl = ['login', 'reset-password'];
    }
    else if (this._preloginService.getFlow() == 'forgotUserId') {
      this.state.navBackUrl = ['login', 'identity-yourself'];
      this._resultService.setService(EPreloginServiceCode.FORGOT_USERNAME);
    }
    else if (this._preloginService.getFlow() == 'reactivateUser') {
      this.state.navBackUrl = ['login', 'identity-yourself'];
    }
    else if (this._preloginService.getFlow() == 'selfRegister') {
      this.state.navBackUrl = ['selfRegister', 'identity-yourself'];
      this.state.navNextUrl = ['selfRegister', 'reset-password'];
    }

  }

  public doConfirm(context: any, success: any, failure: any) { }

  public doResendOtp(context: any, success: any, failure: any) {

    context = { "invNumber": this.state.additionalDetails.refNo };
    this.state.otpVerify = false;
    if (this.state.additionalDetails?.serviceName) {
      context['serviceName'] = this.state.additionalDetails?.serviceName;
    }
    // let apiKey = this._preloginService.getFlow() == 'postLogin'?'tranresendotp':'resendotp';
    this._commonService.showSpinner();
    this.otpPageService.doResendOtp(context).subscribe(
      (res) => {
        this._commonService.hideSpinner();
        this.state.submitclickCount = 3;
        this.state.activeSpan = this.state.submitclickCount.toString();
        success(res);
      },
      (err) => {
        this._resultService.additionalFields = []
        this._commonService.hideSpinner();
        this.state.activeSpan = this.state.submitclickCount.toString();
        let additionalNavigation: IResultNavigationDetails[];
        let retryRequired = false;
        this.state.isError = true;
        this.state.otpError = err.error.errorDesc;
        let errMsg = err.error.errorCode == "002" ? EPreloginServiceCode.RESEND_LIMIT_EXCEEDED : null;
        if (Object.keys(this.dialogRef).length) this.dialogRef.close();
        if (this._preloginService.getFlow() == 'postLogin') {
          retryRequired = true;
        }
        else {
          additionalNavigation = [
            {
              path: this.getRetryUrl(this._preloginService.getFlow()),
              btnLabel: this.translate.instant('OTPPAGE.retry'),
              btnType: 'primary',
            }
          ];
        }
        this._resultService.setFailure(
          err,
          retryRequired,
          errMsg,
          null,
          additionalNavigation,
          EPreloginServiceCode.TRY_AGAIN,
        );
        failure(err);
      }
    );
  }

  getRetryUrl(flow) {
    let retryUrl = [];
    switch (flow) {
      case 'trouble-login': retryUrl = ['login', 'trouble-login']; break;
      case 'selfRegister': retryUrl = ['selfRegister', 'identity-yourself']; break;
      case 'forgotUserId': retryUrl = ['login', 'identity-yourself']; break;
      default: retryUrl = ['login', 'trouble-login']; break;
    }
    return retryUrl;
  }

  public doSubmit(formgroup, context: any, success: any, failure: any) {
    context = {
      /* "serviceName": this._preloginService.getServiceCode(), */
      "otp": context,
      "referenceNumber": this.state.additionalDetails.refNo
    };
    if (this.state.additionalDetails?.serviceName) {
      context['serviceName'] = this.state.additionalDetails?.serviceName;
    }
    const payload: any = {};
    let apiKey = 'otpverify';
    payload[apiKey] = context;

    this._commonService.showSpinner();
    this.otpPageService.doSubmit(apiKey, payload).subscribe(
      async (res) => {
        let options: any = {
          queryParams: {
            "additionalDetails": this.state.additionalDetails
          },
          queryParamsHandling: "preserve",
        }
        let additionalNavigation: IResultNavigationDetails[] = []
        if (sessionStorage.getItem('forgotMPIN') == "1") {
          this._router.navigate(['login', 'setMPIN']);
        } else if (this.state.navNextUrl == 'doWelcome') {
          const expireTime = this._preloginService._userService.getExpiresin();
          this._preloginService.invokeRefreshTokenTimer(Number(expireTime));
          if(!this._commonService.isHybrid()){
            this._preloginService.doWelcome();
          } 
        } else if (this._preloginService.getFlow() == 'reactivateUser') {
          additionalNavigation.push({
            path: ['login'],
            btnLabel: this.translate.instant('FORM_ACTIONS.login'),
            btnType: 'link',
          }, {
            path: ['login', 'trouble-login'],
            btnLabel: this.translate.instant('FORM_ACTIONS.resetPassword'),
            btnType: 'primary',
          }
          )
          // additionalNavigation[0].btnType = 'link';
          let respon: any = res
          let successMsg = respon?.body?.status
          this._resultService.setSuccess(
            res,
            successMsg,
            null,
            additionalNavigation,
            null,
            false
          );
          if (this._commonService.isDesktop()) {
            // this.openResultDialog()
          }
        }
        else if (this._preloginService.getFlow() == 'forgotUserId') {
          let additionalNavigation: IResultNavigationDetails[] = [
            {
              path: ['login'],
              btnLabel: this.translate.instant('FORM_ACTIONS.login'),
              btnType: 'primary',
            }
          ];

          let successMsg = this._preloginService.getFlow() == 'reactivateUser' ? EPreloginServiceCode.REACTIVATE_ACCOUNT : EPreloginServiceCode.FORGOT_USERNAME;
          this._resultService.setSuccess(
            res,
            successMsg,
            null,
            additionalNavigation,
            null,
            false
          );
          this.openResultDialog()

        }
        else {
          if (this._preloginService.getFlow() == 'selfRegister') this._preloginService.updateProgessTab('resetPassword');
          if (this._preloginService.getFlow() != 'reactivateUser') {
            this._router.navigate(this.state.navNextUrl, options);
          }

        }
        this._customerService.checkPrimaryUser().then(
          res => {

          }
        );
        success(res);
      },
      (err) => {
        this._commonService.hideSpinner();
        this._resultService.additionalFields = [];
        formgroup.controls['otpInput'].reset('');
        this.state.activeSpan = this.state.submitclickCount.toString();
        if (err && err.error.errorCode == "004") { // otp expired
          this.state.isError = true;
          this.state.otpError = err.error.errorDesc;
          return;
        } else if (err && err.error.errorCode == "005") { // otp invalid
          let count = --this.state.submitclickCount;
          if (count != 0) {
            this.state.isError = true;
            this.state.otpError = this.translate.instant('OTPPAGE.otpErrorMsg') + ' ' + this.state.submitclickCount + this.translate.instant('OTPPAGE.otpMsg');
            return;
          }
          else if (count == 0) {
            let additionalNavigation: IResultNavigationDetails[] = [];
            additionalNavigation = [
              {
                path: this.getRetryUrl(this._preloginService.getFlow()),
                btnLabel: this.translate.instant('OTPPAGE.retry'),
                btnType: 'primary',
              }
            ];
          }

        }
        else if (err && err.error.errorCode == "OF400-002") { // exceet no of attenmps
          this.state.isError = true;
          this.state.otpError = this.translate.instant('OTPPAGE.errorOtpMsg')
        }
        let additionalNavigation: IResultNavigationDetails[] = [];
        let retryRequired: boolean = false;
        if (Object.keys(this.dialogRef).length) this.dialogRef.close();

        if (this._preloginService.getFlow() == 'postLogin') {
          retryRequired = true;
        }
        else {
          additionalNavigation = [
            {
              path: this.getRetryUrl(this._preloginService.getFlow()),
              btnLabel: this.translate.instant('OTPPAGE.retry'),
              btnType: 'primary',
            }
          ];
        }
        this._resultService.setFailure(
          err,
          retryRequired,
          EPreloginServiceCode.OTP_EXCEED_ERROR,
          null,
          additionalNavigation,
        );
        failure(err);
      }
    );
  }


  openResultDialog() {

    let dialogRef;
    let _data: IPopupScreenData = {
      screenData: {
        resultPageData: this._resultService.resultPageData,
      },
      screenTitle: "",
      component: 'result'
    }
    dialogRef = this._dialog.open(InfoPopupComponent, {
      width: '100%',
      data: _data,
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });

  }

  onClickBackBtn() {
    // this.dialogRef.close();
    this._router.navigate(this.state.navBackUrl)
  }

  resetScreenData() {
    this.state.navNextUrl = '';
    this.state.navBackUrl = '';
    this.state.mobileNum = '';
    this.state.emailId = '';
    this.state.additionalDetails = '';
    this.state.expireSec = 300;
    this.state.countDown.unsubscribe();
    this.state.displayTimer = '';
    this.state.otpError = '';
    this.state.isError = false;
    this.state.buttonEnable = false;
    this.state.otpVerify = false;
    this.state.submitclickCount = 4;
  }

  submitChannel(otpChannelOption):Observable<any> {
    let payload = {
      "channelType": otpChannelOption,
      "referenceNumber": this.state.additionalDetails.refNo,
      "stageCode": "INIT",
    };
    if (this.state.additionalDetails?.serviceName) {
      payload['processCode'] = this.state.additionalDetails?.serviceName;
    }

   
    return this.otpPageService.submitChannel(payload);
  }


}
